import { createContext } from 'react';

export const StorageCtx = createContext(null);
